module.exports = __webpack_public_path__ + "img/title.78eafd6f.png";